var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Button } from "syf-component-library/ui/atoms";
export var ManageProfileButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0px;\n  margin: 16px 0px 0px;\n"], ["\n  padding: 0px;\n  margin: 16px 0px 0px;\n"])));
var templateObject_1;
